import { createStore, createLogger } from 'vuex'

import mutations from './mutations'
import actions from './actions'
import getters from './getters'
import app from './modules/app'
import guide from './modules/guide'

const state = {
  user: null,
  yearCycles: [],
  activeYearIndex: -1,
  selectedCycleId: null,
  users: [],
  userMap: {},
  menu: {
    selectedKeys: [],
    openKeys: []
  }
}

const plugins = process.env.NODE_ENV !== 'production'
  ? [createLogger()]
  : []

export default createStore({
  state,
  getters,
  mutations,
  actions,
  modules: {
    app,
    guide
  },
  plugins
})
